import Indian_warriors from '../today-i-learned-images/Indian_warriors.jpg'
import gates_of_all_nations from '../today-i-learned-images/gates_of_all_nations.jpg'

const FirstIndianSoldiersAtThermopylaeContent = {
  title : "Indian Soldiers at Thermopylae: The First Recorded Entry of Indians into Europe",
  paragraphs : [
    {   
      heading: 'Before Alexander the Great', 
      content: (
        <>
          <p>
            Almost 170 years before Alexander, around 500 BCE there was the Achaemenid Empire at its largest extent. To the east, while the Gandhara and Taxila were under its control, borders were shared by the Indian mahajanapadas, with Magadha being the most powerful in the immediate east. To the west, the empire bordered Macedon, then a minor kingdom that would later expand under Philip II and be transformed by his son, Alexander the Great, who later conquered the Achaemenid Empire. 
          </p>
        </>
      )
    },
    {
      heading: 'Indian Troops in Xerxes’ Campaign',
      content: (
        <>
          <p>
            In 480 BCE, one of the most famous last stands, the Battle of Thermopylae (on which the movie 300 was made) was fought between Achaemenid Empire led by Xerxes I and a coalition of Greek city-states led by Spartan king Leonidas I. The Achaemenid army was a vast, multi-ethnic force drawn from across the empire. Herodotus explicitly lists Indians almost certainly from Gandhara serving in this campaign.
            <br/>
            <figure className='text-center'>
              <img
                  src={Indian_warriors}
                  alt="Indian soldiers on the tomb of Xerxes I"
                  className="my-4 mx-auto"
                  loading="lazy"
                  width="330"
                  height="270"
              />
              <figcaption>
                  Indian soldiers on the tomb of Xerxes I
              </figcaption>
            </figure>
            <br/>
            This marks the earliest recorded instance of soldiers from the Indian subcontinent fighting on European soil.
          </p>
        </>
      )
    },
    {
      heading: 'Artistic Influence in India',
      content: (
        <>
          <p>
            The Lion Capital of Ashoka, now India’s national emblem, shows designs linked to Achaemenid artistic tradition. The inverted-lotus base and aspects of the lions’ mane and eyes can also be seen in Persian architecture. Similar inverted-lotus bases appear on the columns of the Gate of All Nations at Persepolis, which interestingly was ordered to be constructed by Xerxes I. Mauryans adapted these motifs in Ashokan pillars.
            <br/>
            <figure className='text-center'>
              <img
                  src={gates_of_all_nations}
                  alt="gates of all nations"
                  className="my-4 mx-auto md:w-1/2"
                  loading="lazy"
                  width="640"
                  height="418"
              />
              <figcaption>
                  Pillars at the Gates of All Nations
              </figcaption>
            </figure>
          </p>
        </>
      )
    },
    {
      heading: 'Why This Episode Matters',
      content: (
        <>
          <p>
            The presence of Indian troops at Thermopylae highlights that the history of early Indo-European interaction is deeper and more interconnected than commonly assumed. It also serves as one of the earliest examples of Indian political, military, and artistic entanglement with the wider world, centuries before the Indo-Greek kingdoms or the campaigns of Alexander the Great.
          </p>
        </>
      )
    }
  ]
}

export default FirstIndianSoldiersAtThermopylaeContent;